exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suspended{color:#ed1c24 !important}\n", ""]);

// exports
